export const TARGETS_BASE_PATH = '/monitoring-target';
